// Define the type for a single action
interface ExportConfig {
    exportDeadline: string, //10 minutes: number;
    pollingInterval: number;
    chartConditionNotMet: number; // Optional property for chart condition not met
}
  
  // Define the PAGES constant
export const EXPORT: ExportConfig = {
    exportDeadline: "P0Y0M0DT1H0M0S", //1 hour
    pollingInterval: 5000,
    chartConditionNotMet: 7005
};